export default __webpack_public_path__ + "static/media/Grupo6136.bff65ecc.svg";